import { AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, Input, Output, SimpleChanges, ViewChild } from "@angular/core";
import { ITestimonialsItemData } from "../../testimonials-panel.component";
import { getButtonStyle } from "../../../../shared/utils/get-button-style";
import { TranslateService } from '@ngx-translate/core';
import {
  trigger,
  transition,
  style,
  animate,
  state
} from '@angular/animations';

@Component({
  selector: "app-testimonials-panel-info",
  templateUrl: "./testimonials-panel-info.component.html",
  styleUrls: ['./testimonials-panel-info.component.less'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class TestimonialsPanelInfoComponent implements AfterViewInit {
  @Input() item: ITestimonialsItemData;
  @Input() forceHideQuoteId: number;
  @Output() readMoreActivated = new EventEmitter<void>();

  readMoreButtonText: string = "Læs mere";
  readMoreButtonClass: string = "bg-navy-button";
  readLessButtonText: string = "Læs mindre";
  showQuote: boolean = true;
  hasReadMoreButton: boolean = true;

  private heightCheckInterval: any;
  lastKnownHeight = 0;

  @ViewChild('textEl', { static: false }) textEl: ElementRef<HTMLElement>;
  @ViewChild('linksEl', { static: false }) linksEl: ElementRef<HTMLElement>;

  @HostBinding('class.testimonials-panel-info--big-pictures')
  get isBigPictures(): boolean {
    return this.item.bigPictures;
  }

  constructor(private hostRef: ElementRef, private translate: TranslateService) { }

  ngOnInit() {
    if (this.item.readMoreDescriptionButton && this.item.readMoreDescriptionButton.value && this.item.readMoreDescriptionButton.value.length) {
      this.showQuote = false;

      if (this.item.quote && this.item.quote.value) {
        this.setReadMoreButtonProperties();
      }
    }
  }

  ngAfterViewInit(): void {
    this.setCustomThemeProperties(this.item);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.forceHideQuoteId && !changes.forceHideQuoteId.firstChange
      && this.item.readMoreDescriptionButton && this.item.readMoreDescriptionButton.value
      && this.item.readMoreDescriptionButton.value.length) {
      this.showQuote = false;
    }
  }

  ngOnDestroy(): void {
    if (this.heightCheckInterval) {
      clearInterval(this.heightCheckInterval);
      this.heightCheckInterval = null;
    }
  }

  readMoreClick() {
    this.readMoreActivated.emit();
    this.showQuote = !this.showQuote;
  }

  private setReadMoreButtonProperties() {
    const buttonData = this.item.readMoreDescriptionButton.value[0];

    this.translate.get('testimonialsPanel.Info.ReadMore').subscribe((translated: string) => {
      this.readMoreButtonText = buttonData && buttonData.buttonText && buttonData.buttonText.value
        ? buttonData.buttonText.value
        : translated;
    });

    this.translate.get('testimonialsPanel.Info.ReadLess').subscribe((translated: string) => {
      this.readLessButtonText = buttonData && buttonData.buttonText && buttonData.buttonText.value
        ? buttonData.buttonText.value
        : translated;
    });

    if (!buttonData) return;

    if (buttonData.buttonText && buttonData.buttonText.value) {
      this.readMoreButtonText = buttonData.buttonText.value;
    }
    if (buttonData.buttonOffText && buttonData.buttonOffText.value) {
      this.readLessButtonText = buttonData.buttonOffText.value;
    }

    if (buttonData.buttonColor && buttonData.buttonColor.value) {
      const buttonStyle = getButtonStyle(buttonData.buttonColor.value);
      this.readMoreButtonClass = buttonStyle && buttonStyle.buttonClass;
    }
  }

  private setCustomThemeProperties(d: ITestimonialsItemData) {
    const root = this.hostRef.nativeElement;

    if (d.textColor && d.textColor.value) {
      root.style.setProperty(
        "--testi-panel-info-text-color",
        d.textColor.value
      );
    }

    if (d || d.readMoreDescriptionButton || d.readMoreDescriptionButton.value || d.readMoreDescriptionButton.value.length) {
      const buttonData = d.readMoreDescriptionButton.value[0];
      if (!buttonData) return;

      if (buttonData.buttonFontWeight && buttonData.buttonFontWeight.value) {
        root.style.setProperty(
          "--readmore-button-font-weight",
          buttonData.buttonFontWeight.value
        )
      }
      if (buttonData.buttonTextSize && buttonData.buttonTextSize.value) {
        root.style.setProperty(
          "--readmore-button-text-size",
          buttonData.buttonTextSize.value
        )
      }
    }
  }
}
